// extracted by mini-css-extract-plugin
export default {"loginCon":"styles_loginCon__hnrSB","body":"styles_body__EXcfZ","flex":"styles_flex__cZhnA","btn":"styles_btn__DT66c"};